import React from "react";

import { Plus } from "icons";

import { Button, SubHeader } from "clearsense-ui/components";

const PrimaryHeader = ({ setIsUploadPaneOpen }) => (
  <SubHeader
    className="mt-8 mb-2"
    breadcrumbs={[
      { label: "Upload From Local", link: "#" },
      { label: "Overview", link: "#" },
    ]}
    actionBlock={
      <Button
        label={"New File"}
        icon={Plus}
        data-cy="new-file-button"
        onClick={() => setIsUploadPaneOpen(true)}
      />
    }
  />
);

export default PrimaryHeader;
